import { useTranslation } from 'react-i18next'
import React from 'react'

import { ACTIVITY_TAG_TYPE } from '../../../../../tags/_constants'
import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import TagSelect from '../../../../../../containers/tags/select/TagSelect'
import Text, { Title } from '../../../../../../packages/kiti/components/presentation/Text'

/**
 * Sentença da ação `assign_tag`, no mesmo padrão de `UpdateStatusSentence`/`LockPlaceSentence`:
 * um link editável que abre um modal com um único campo (a tag a ser atribuída), guardado em
 * `payload.tag` (objeto `{id, name, color}`) e convertido para `payload: {tag_id}` em
 * `cleanRequest.js` antes de enviar ao backend.
 */
const AssignTagSentence = () => {
  const { t } = useTranslation('triggers')
  const [open, setOpen] = React.useState()
  const { form } = useFormState()

  return (
    <>
      <Text size="h2">{t('assignTag.to')} </Text>
      <EditableSentence
        label={form.payload?.tag?.name || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="28rem">
        <Title size="h5" bold>
          {t('actions.assign_tag')}
        </Title>

        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem
              label={t('assignTag.tag')}
              path={['payload', 'tag']}
              Input={TagSelect}
              type={ACTIVITY_TAG_TYPE}
              allowCreate={false}
            />
          </Col>
        </Grid>
        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default AssignTagSentence
